import React, { useMemo } from "react";
import { useTable } from "react-table";
import { useHistory } from "react-router-dom";

import { DelayLink } from "./DelayLink";
import "./../styles/Tables.css";
import DialogBox from "./DialogBox";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";

export const TaskTableClinical = (props) => {
  var dynamicData = "";
  var dynamicColumn = "";
  var buttonDisplay = "";

  dynamicColumn = props.columns;
  dynamicData = props.tableData;

  if (props.type == "assigned") {
    buttonDisplay = "Start";
  } else if (props.type == "active") {
    buttonDisplay = "Continue"; //"Continue";
  }

  const data = useMemo(() => dynamicData, []);
  const columns = useMemo(() => dynamicColumn, []);

  const tableInstance = useTable({
    columns,
    data,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  const handleId = (e) => {
    console.log(e);
  };

  return (
    <div className="tblDiv">
      <table className="tblDisplay" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps({ style: { width: column.width } })}
                >
                  {" "}
                  {column.render("Header")}
                </th>
              ))}
              <th colSpan="2"></th>
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
                <td>
                  <DelayLink to={`${sessionStorage.getItem("process")}`}>
                    <button
                      id={row.index}
                      onClick={handleId}
                      type="button"
                      className="buttonTbl"
                    >
                      {buttonDisplay}
                    </button>
                  </DelayLink>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <br></br>
    </div>
  );
};

export const BasicTableClinical = (props) => {
  const history = useHistory();
  var dynamicData = "";
  var dynamicColumn = "";
  var buttonDisplay = "";

  dynamicColumn = props.columns;
  dynamicData = props.tableData;

  const data = props.tableData;
  const columns = props.columns;

  const tableInstance = useTable({
    columns,
    data,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  const startTask = (e) => {
    console.log(e);
    sessionStorage.setItem("ActiveTaskID", e.target.dataset.id);
    var redirectPath = "/ClinicalReview";
    console.log("redirect path ", redirectPath);
    history.push(redirectPath);
  };

  var showAddBtn = "";
  if (props.AddButtonText == "" || props.AddButtonText == null) {
    showAddBtn = "btn--hidden";
  } else {
    showAddBtn = "btn--primary";
  }
  var dataForProcess;
  var setterMethod;
  if (props.ButtonID == "BtnCPT") {
    dataForProcess = props.cptData;
    setterMethod = props.setCPTData;
  } else if (props.ButtonID == "BtnDX") {
    dataForProcess = props.dxData;
    setterMethod = props.setDXData;
  } else if (props.ButtonID == "BtnProvider") {
    dataForProcess = props.providerData;
    setterMethod = props.setProviderData;
  }
  return (
    <div className="tblDiv">
      <DialogBox
        processData={dataForProcess}
        setterMethod={setterMethod}
        buttonStyle={showAddBtn}
        AddButtonText={props.AddButtonText}
        ButtonID={props.ButtonID}
        taskStatus={props.taskStatus}
        proc={"add"}
      ></DialogBox>
      <table className="tblDisplay" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            if (props.tableType == "default") {
              return (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {" "}
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              );
            } else if (props.tableType == "editable") {
              return (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {" "}
                      {column.render("Header")}
                    </th>
                  ))}
                  {props.taskStatus != 3 ? <th colSpan="2"></th> : ""}
                </tr>
              );
            } else if (props.tableType == "startBtn") {
              return (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {" "}
                      {column.render("Header")}
                    </th>
                  ))}
                  <th colSpan="4"></th>
                </tr>
              );
            }
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            if (props.tableType == "default") {
              return (
                <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                  {row.cells.map((cell) =>
                    // {
                    //   return (
                    //     <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    //   );
                    // }
                    {
                      if (cell.column.Header === "Task ID") {
                        // If the column header is 'CASE NO', render a link
                        return (
                          <td {...cell.getCellProps()}>
                            {/* {props.activeStyle.audited &&
                            cell.row.original["rebuttal_flag"] == 1 ? (
                              <FlagCircleIcon style={{ color: "#FB4E0B" }} />
                            ) : (
                              <FlagCircleIcon
                                style={{ color: "#FB4E0B", opacity: "0" }}
                              />
                            )}{" "} */}
                            {props.activeStyle.audited ? (
                              cell.row.original["rebuttal_flag"] == 1 ? (
                                <FlagCircleIcon style={{ color: "#FB4E0B" }} />
                              ) : (
                                <FlagCircleIcon
                                  style={{ color: "#FB4E0B", opacity: "0" }}
                                />
                              )
                            ) : (
                              ""
                            )}
                            <span
                              style={{
                                color: "#FB4E0B",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontWeight: "bolder",
                              }}
                              data-id={cell.value}
                            >
                              {cell.render("Cell")}
                            </span>
                          </td>
                        );
                      } else {
                        // For other columns, render a regular table cell
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      }
                    }
                  )}
                </tr>
              );
            } else if (props.tableType == "editable") {
              return (
                <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                  {props.taskStatus != 3 ? (
                    <td>
                      <DialogBox
                        className="buttonTbl"
                        processData={dataForProcess}
                        buttonStyle={showAddBtn}
                        AddButtonText={"Update"}
                        ButtonID={props.ButtonID}
                        setterMethod={setterMethod}
                        proc={"update"}
                        rowID={row.id}
                      >
                        <i className="fas fa-pen"></i>
                      </DialogBox>
                    </td>
                  ) : (
                    ""
                  )}
                  {props.taskStatus != 3 ? (
                    <td>
                      <DialogBox
                        className="buttonTbl"
                        processData={dataForProcess}
                        buttonStyle={showAddBtn}
                        AddButtonText={"Remove"}
                        ButtonID={props.ButtonID}
                        setterMethod={setterMethod}
                        proc={"delete"}
                        rowID={row.id}
                      >
                        <i className="fas fa-trash"></i>
                      </DialogBox>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              );
            } else if (props.tableType == "startBtn") {
              return (
                <tr {...row.getRowProps({ style: { textAlign: "center" } })}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                  <td>
                    <button type="button" className="buttonTbl">
                      <i
                        className="fas fa-play-circle"
                        data-id={row.values.taskID}
                        onClick={startTask}
                      ></i>
                    </button>{" "}
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
      <br></br>
    </div>
  );
};
